<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import medicionFrecuenciaAPI from "@/services/standards/medicionFrecuencia/medicionFrecuenciaAPI";
import Swal from "sweetalert2";
import ScoreAPI from "@/services/standards/score/scoreAPI";
import ItemAPI from "@/services/items/itemsAPI";
import CheckModal from "@/components/CheckModal";
import indicadoresAPI from "../../../services/standards/indicadores/indicadoresAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "Indicadores de Estructura, Proceso y Resultado",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    CheckModal,
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "6.1.1 Indicadores de Estructura, Proceso y Resultado",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Indicadores de Estructura, Proceso y Resultado",
        },

        {
          text: "Editar",
          active: true,
        },
      ],

      itemData: null,
      item: null,
      itemStatus: null,
      submitted: false,
      years: [],
      lista: [],
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID:
        this.$store.getters["company/getCompany"].company_classification_id ||
        null,
      user: this.$store.state.auth || null,

      indicador: {
        annual_goal: null,
        year: null,
        people_know_result: null,
        responsible_measurement: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(36)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 36)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status ? response.status : null;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeItemStatus(item, itemStatus) {
      if (item) {
        const itemChange = {
          items_id: item.items_id,
          status: itemStatus,
          operation: item.operation,
          puntation_absoluta: item.puntation_absoluta,
          puntation_relative: item.puntation_relative,
        };
        CompanyItemsAPI.updateStatus(this.companyID, itemChange)
          .then((response) => {
            if (
              response.message ===
              "item actualizado con exito, se ha sumado el valor del item , en la puntuacion" ||
              response.message === "item actualizado con exito"
            ) {
              Swal.fire({
                title: "¡Se ha actualizado el estado del ítem con éxito!",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
            } else {
              Swal.fire({
                title: "No se ha podido actualizar el estado del ítem",
                type: "warning",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    getStatusItem(ID, item, itemStatus) {
      CompanyItemsAPI.getStatus(this.companyID, ID)
        .then((response) => {
          item = response || null;
          itemStatus = response.status;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    save() {
      this.submitted = true
      indicadoresAPI
        .update(this.$route.params.id, {
          annual_goal: this.indicador.annual_goal,
          year: this.indicador.year,
          people_know_result: this.indicador.people_know_result,
          responsible_measurement: this.indicador.responsible_measurement,
          companies_id: this.indicador.companies_id,
        })
        .then((response) => {
          this.submitted = false
          setTimeout(() => {
            Swal.fire({
              title: "Informacion actualizada con éxito!",
              type: "success",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            this.$router.go(-1);
          }, 1000);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getShow() {
      indicadoresAPI
        .getShow(this.$route.params.id)
        .then((response) => {
          this.loading = false;
          this.indicador = {
            annual_goal: response.data.annual_goal,
            year: response.data.year,
            people_know_result: response.data.people_know_result,
            responsible_measurement: response.data.responsible_measurement,
            companies_id: response.data.companies_id,
          };
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      medicionFrecuenciaAPI
        .getAll(this.companyID)
        .then((response) => {
          let medicion = response.data.data;
          this.lista = medicion;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    rangeYear() {
      const max = 2040;
      const min = 2019;
      for (let i = min; i <= max; i++) {
        this.years.push(i);
      }
      return this.years
    },

    goPage(page) {
      window.location.href = page;
    },
  },

  mounted() {
    this.rangeYear();
    this.getList();
    this.getItems();
    this.getItemData();
    this.getShow();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12 m-0 p-0">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 text-right m-b-0">
                <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                  <i class="fas fa-arrow-left"></i>
                </div>
                <b-tooltip target="back" placement="left"> Volver </b-tooltip>
              </div>
            </div>

            <hr />

            <form class="form-group" @submit.prevent="save">
              <div class="table-responsive px-4 mt-2" v-if="getRole('Consultar')">
                <table class="table-sm pt-2 table border-bottom divide-y divide-gray-200 table-bordered rounded">
                  <thead class="bg-primary text-light">
                    <tr>
                      <th class="text-center align-middle" colspan="4">
                        Ficha técnica del indicador
                      </th>
                    </tr>
                    <tr>
                      <th class="text-center align-middle">Nombre indicador</th>
                      <th class="text-center align-middle" colspan="3">
                        Cumplimiento de los indicadores de estructura proceso y
                        resultado del SG-SST
                      </th>
                    </tr>
                  </thead>
                  <tbody class="">
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Fórmula</b>
                      </td>
                      <td class="text-center align-middle" colspan="3">
                        (Numero de items Cumplidos/ Número de ítems Evaluados) *
                        100
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Interpretación del indicador</b>
                      </td>
                      <td class="text-center align-middle" colspan="3">
                        La empresa cumple con un X% de los items evaluados de
                        los indicadores de estructura proceso y resultado del SG
                        SST
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b> Meta</b>
                      </td>

                      <td class="text-center align-middle d-flex justify-content-center" colspan="2">
                        <b-form-input class="col-md-4" type="number" id="date_exam" v-model="indicador.annual_goal">
                        </b-form-input>
                      </td>
                      <td class="text-center align-middle">
                        <select required class="col-md-8 form-control" v-model="indicador.year">
                          <b-form-select-option v-for="item in years" :value="item">
                            {{ item }}
                          </b-form-select-option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b> Periodicidad</b>
                      </td>
                      <td class="text-center align-middle" colspan="1">
                        Anual
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Fuente de la información</b>
                      </td>
                      <td class="align-middle" colspan="3">
                        <p>
                          Soporte de cumplimieto de cada uno de los ítems
                          solicitados en los indicadores
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b> Personas que deben conocer el resultado</b>
                      </td>
                      <td class="text-center align-middle" colspan="3">
                        <b-form-input type="text" id="date_exam" maxlength="200" v-model="indicador.people_know_result">
                        </b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b> Responsable de la medición </b>
                      </td>
                      <td class="text-center align-middle" colspan="3">
                        <b-form-input type="text" id="date_exam" maxlength="200"
                          v-model="indicador.responsible_measurement">
                        </b-form-input>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
